import { buildUrl } from 'shared/helpers/utils/url-builder';
import type {
  RegionPageParams,
  BuildingPageParams,
  EducationClassPageParams,
  SchedulePageParams,
  EducationPlanOopPageParams,
  ConfigurationSchedulesPageParams,
  ScheduleConfigurationFormPageParams,
  EducationPlanPageParams,
  TeacherWorkloadPageParams,
} from './types';
import { appPagePaths } from './urls';

export const getHomeUrl = () => appPagePaths.home;
export const getLogoutUrl = () => appPagePaths.logout;
export const getSignUpUrl = () => appPagePaths.signUp;
export const getAuthorizationUrl = () => appPagePaths.authorization;
export const getOrganizationsUrl = () => appPagePaths.organizations;
export const getBuildingsUrl = () => appPagePaths.buildings;
export const getBuildingUrl = (params: BuildingPageParams) =>
  buildUrl(appPagePaths.building, params);
export const getEducationClassesUrl = () => appPagePaths.educationClasses;
export const getEducationClassUrl = (params: EducationClassPageParams) =>
  buildUrl(appPagePaths.educationClass, params);
export const getMunicipalitiesUrl = () => appPagePaths.municipalities;
export const getRegionsUrl = () => appPagePaths.regions;
export const getRegionUrl = (params: RegionPageParams) => buildUrl(appPagePaths.region, params);
export const getUsersUrl = () => appPagePaths.users;
export const getAcademicCalendarUrl = () => appPagePaths.academicCalendar;
export const getProductionCalendarUrl = () => appPagePaths.productionCalendar;
export const getEducationPlansUrl = () => appPagePaths.educationPlans;
export const getEducationPlanUrl = (params: EducationPlanPageParams) =>
  buildUrl(appPagePaths.educationPlan, params);
export const getSubjectDifficultiesUrl = () => appPagePaths.subjectDifficulties;
export const getScheduleForWeekUrl = () => appPagePaths.scheduleForWeek;
export const getConfigurationSchedulesUrl = (params: ConfigurationSchedulesPageParams) =>
  buildUrl(appPagePaths.configurationSchedules, params);
export const getScheduleConfigurationFormUrl = (
  params?: ScheduleConfigurationFormPageParams,
): string => {
  const searchParams: Record<string, string> = {};
  if (params?.configurationId != null) searchParams.configurationId = params.configurationId;
  if (params?.copy != null) searchParams.copy = params.copy;
  return buildUrl(appPagePaths.scheduleConfigurationForm, {}, searchParams);
};
export const getScheduleUrl = (params: SchedulePageParams) =>
  buildUrl(appPagePaths.schedule, params);
export const getEducationPlanOopUrl = (params: EducationPlanOopPageParams) =>
  buildUrl(appPagePaths.educationPlanOop, params);
export const getTeacherWorkloadsUrl = () => appPagePaths.teacherWorkloads;
export const getClassGroupsUrl = () => appPagePaths.classGroups;
export const getTeacherWorkloadUrl = (params: TeacherWorkloadPageParams) =>
  buildUrl(appPagePaths.teacherWorkload, params);
export const getBellSchedulesUrl = () => appPagePaths.bellSchedules;
export const getMaxLessonsPerDayUrl = () => appPagePaths.maxLessonsPerDay;
